import React from 'react';
import MoneyIcon from './MoneyIcon';

const DecorativeEmojis = () => (
  <>
    <MoneyIcon className="icon-1" delay="0s">
      💰
    </MoneyIcon>
    <MoneyIcon className="icon-2" delay="1s">
      💵
    </MoneyIcon>
    <MoneyIcon className="icon-3" delay="2s">
      🪙
    </MoneyIcon>
    <MoneyIcon className="icon-4" delay="0.5s">
      💸
    </MoneyIcon>
  </>
);

export default DecorativeEmojis;
